export default __webpack_public_path__ + "static/media/tab2_2.f1fbdd9b.png";